import {
  type EventBusConnectionStateEnum,
  EventBusConnectionStates,
} from '@webapp/infrastructure/interfaces/services/IEventBus'

/**
 * Visibility modes for Pusher channels.
 */
export const ChannelVisibility = {
  PUBLIC: 'public',
  PRIVATE: 'private',
  PRESENCE: 'presence',
  PRIVATE_ENCRYPTED: 'private-encrypted',
} as const

/**
 * Channel visibility prefixes used by Pusher.
 */
export const CHANNEL_PREFIX = {
  PRIVATE: 'private-',
  PRESENCE: 'presence-',
  PRIVATE_ENCRYPTED: 'private-encrypted-',
} as const

/**
 * Maps Pusher connection states to normalized EventBus states.
 * @see https://pusher.com/docs/channels/using_channels/connection/#available-states
 */
export const PusherToEventBusState = {
  initialized: EventBusConnectionStates.CONNECTING,
  connecting: EventBusConnectionStates.CONNECTING,
  unavailable: EventBusConnectionStates.CONNECTING,
  connected: EventBusConnectionStates.CONNECTED,
  failed: EventBusConnectionStates.DISCONNECTED,
  disconnected: EventBusConnectionStates.DISCONNECTED,
} as const satisfies Record<string, EventBusConnectionStateEnum>
